export default __webpack_public_path__ + "static/210308_KMW_by_Kruszewski__MK_1693_V5-35c6c40e421320b920025746ce70a505.jpg";